import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../context/LocaleContext';

const ForgotPassword = () => {
  const { t } = useLocale();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-[420px]">
        <div className="auth-card px-7 py-9 sm:px-10">
          <Link to="/login" className="auth-back">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            </svg>
            {t('backSignIn')}
          </Link>
          <h1 className="text-[1.75rem] font-medium text-gray-900 tracking-tight">{t('forgotTitle')}</h1>
          <p className="mt-2 text-sm text-gray-500 leading-relaxed">
            {t('forgotLead')}
          </p>

          {sent ? (
            <div className="mt-8 rounded-2xl bg-[#fafafa] border border-[#f3f2f6] px-4 py-4 text-sm text-gray-600 leading-relaxed">
              {t('nothingSent', { email })}
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="mt-8 space-y-5">
              <div>
                <label htmlFor="reset-email" className="block text-sm font-medium text-gray-700 mb-2">
                  {t('email')}
                </label>
                <input
                  id="reset-email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="auth-input auth-input-plain"
                />
              </div>
              <button type="submit" className="auth-submit">
                {t('continue')}
              </button>
            </form>
          )}

          <p className="mt-7 pt-6 text-center text-sm text-gray-500 border-t border-[#f3f2f6]">
            {t('remembered')}{' '}
            <Link to="/login" className="nav-link font-medium text-purple-700 hover:text-purple-900">
              {t('signIn')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
